import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/Common";

export const getCarriers = async () => {
  const { data } = await axios.get(`${api_base_url}/Carriers`);
  return data;
};

export const getActiveCarriers = async () => {
  const { data } = await axios.get(`${api_base_url}/ActiveCarriers`);
  return data;
};

export const getPolicyType = () => {
  return axios.get(`${api_base_url}/policytype`).then((res) => {
    return res.data;
  });
};

export const getLicenseType = () => {
  return axios.get(`${api_base_url}/licensetype`).then((res) => {
    return res.data;
  });
};

export const getStates = () => {
  return axios.get(`${api_base_url}/States`).then((res) => {
    return res.data;
  });
};

export const getAgency = () => {
  return axios.get(`${api_base_url}/agency`).then((res) => {
    return res.data;
  });
};

//for Agency drop downs options
export const getOfficeBrands = () => {
  return axios.get(`${api_base_url}/officeBrand`).then((res) => {
    return res.data;
  });
};

export const getMappedAgency = () => {
  return axios.get(`${api_base_url}/mappedagency`).then((res) => {
    return res.data;
  });
};

export const getLegalEntity = () => {
  return axios.get(`${api_base_url}/legalentity`).then((res) => {
    return res.data;
  });
};

export const getTargetSystem = () => {
  return axios.get(`${api_base_url}/targetsystem`).then((res) => {
    return res.data;
  });
};

export const getOperationsGroup = () => {
  return axios.get(`${api_base_url}/Operations`).then((res) => {
    return res;
  });
};

export const getModules = () => {
  return axios.get(`${api_base_url}/modules`).then((res) => {
    return res.data;
  });
};
export const getOperations = () => {
  return axios.get(`${api_base_url}/operations`).then((res) => {
    return res.data;
  });
};

export const getCount = async (userName, isFranchise) => {
  return axios
    .get(
      `${api_base_url}/GetNotificationCount?userName=${userName}&isFranchise=${isFranchise}`
    )
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};
export const getNotifications = async (userName, isFranchise) => {
  return axios
    .get(
      `${api_base_url}/GetNotification?userName=${userName}&isFranchise=${isFranchise}&type=1`
    )
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};
export const getAllNotifications = async (userName, isFranchise) => {
  return axios
    .get(
      `${api_base_url}/GetNotification?userName=${userName}&isFranchise=${isFranchise}&type=2`
    )
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};
export const insertNotificationStatus = async (userId, requestId) => {
  return axios
    .post(`${api_base_url}/InsertNotificationStatus/${userId},${requestId}`)
    .then((res) => {
      return res.data;
    });
};
//clearNotificationStatus
export const clearNotificationStatus = async (userName) => {
  return axios
    .get(`${api_base_url}/ClearNotificationStatus/${userName}`)
    .then((res) => {
      return res.data;
    });
};

export const getGLEntity = () => {
  return axios.get(`${api_base_url}/GLEntity`).then((res) => {
    return res.data;
  });
};

export const getDistChannel = () => {
  return axios.get(`${api_base_url}/DistributionChannel`).then((res) => {
    return res.data;
  });
};

export const uploadSingleFile = async (file) => {
  var { data } = await axios.post(`${api_base_url}/uploadSingleFile`, file, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const downloadSourceFile = async (fileName) => {
  var response = await axios.get(
    `${api_base_url}/DownloadSourceFile?fileName=${fileName}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    }
  );
  return response;
};

export const getAreas = () => {
  return axios.get(`${api_base_url}/Areas`).then((res) => {
    return res.data;
  });
};

export const getProdCodeTypes = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASEURL}/ProducerCode/ProducerCodeType`
  );
  return data;
};

export const getCodeLevels = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASEURL}/ProducerCode/CodeLevel`
  );
  return data;
};

export const getOfficeBanks = async () => {
  const { data } = await axios.get(`${api_base_url}/OfficeBanks`);
  return data;
};

export const getOfficeAccounts = async () => {
  const { data } = await axios.get(`${api_base_url}/OfficeAccounts`);
  return data;
};
